import {host} from "./http-service";

export const getFileUrl = (fileId: number) => {
    return `${host}files/${fileId}`
}